import React from "react";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { ErrorDesktopOffIcon } from "../Icons/ErrorDesktopOffIcon";
import { useErrorIconSize } from "../Icons/ErrorIconSize";

export const UnsupportedEnvironmentUnspecifiedPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    return (<ErrorPageWrapper
        icon={<ErrorDesktopOffIcon size={iconSize}/>}
        content={<label>Deine Arbeitsumgebung wird leider nicht unterstützt</label>}
    />);
}